import { render, staticRenderFns } from "./TrackAndTraceInformation.vue?vue&type=template&id=92735d12&scoped=true&"
import script from "./TrackAndTraceInformation.vue?vue&type=script&lang=js&"
export * from "./TrackAndTraceInformation.vue?vue&type=script&lang=js&"
import style0 from "./TrackAndTraceInformation.vue?vue&type=style&index=0&id=92735d12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92735d12",
  null
  
)

export default component.exports